import { MenuType } from "@reef-os/utils/enums/menuType"
import { NotificationType } from "@/enums/NotificationType"
import { eventBus, EventBusEvents } from "@/eventBus"
import { PaymentType } from "@reef-os/utils/enums/paymentType"
import { ChargeCardError } from "@/enums/ChargeCardError"

let checkoutMixin = {
    computed: {
        price() {
            return this.$store.getters.price
        },
        minimumNotMet() {
            return this.$store.getters.price < this.minimumOrderAmount
        },
        slug() {
            return this.$route.params.slug
        },
        allowedPaymentMethods() {
			return this.$store.getters.allowedPaymentMethods
		},
        paymentMethods() {
			const methods = []

			if (this.allowedPaymentMethods.includes(PaymentType.CREDIT_CARD)) {
				methods.push({
                    text: "Card",
                    id: PaymentType.CREDIT_CARD
                })
			}

			if (this.googlePaySupported && this.allowedPaymentMethods.includes(PaymentType.GOOGLE_PAY)) {
				methods.push({
					icon: "sk-icon-google-pay-brands",
					id: PaymentType.GOOGLE_PAY
				})
			}

			if (this.applePaySupported && this.allowedPaymentMethods.includes(PaymentType.APPLE_PAY)) {
				methods.push({
					icon: "sk-icon-apple-pay",
					id: PaymentType.APPLE_PAY
				})
			}

			if (this.allowedPaymentMethods.includes(PaymentType.IN_ROOM_BILLING)) {
				methods.push({
					text: "Charge to Room",
					id: PaymentType.IN_ROOM_BILLING
				})
			}

			return methods
		}
    },
    data: function () {
        return {
            chargeSubscription: null,
            applePaySupported: false,
            googlePaySupported: false
        }
    },
    methods: {
        subscribeToChargeEvents: function () {
            this.$store.dispatch("setInPurchaseState", false)
            this.$store.dispatch("setChargeKey")
            this.toggleLoader(false)
            let that = this
            this.chargeSubscription = this.$store.subscribe((mutation, state) => {
                let hasError = false
                let errorMessage = "There was an error processing your payment. Please try again"
                if (mutation.type === "chargedCard" && state.purchase) {
					state.purchase = false
					that.toggleLoader(false)

					let orderID = state.orderID
					if (
						orderID == "" ||
						orderID == null ||
						orderID == undefined
					) {
						hasError = true
						errorMessage =
							"There was an error processing your payment. Please check your credit card information and try again."
					} else {
						that.$store.dispatch("sendMixpanelEvent", {
							msg: "Purchase Done",
							data: {
								type: that.$store.state.paymentMethod
							}
						})
						that.$store.dispatch("clearOrder")
						that.chargeSubscription()
						const successRoute = {
							name: "track",
							params: { order_id: orderID, slug: that.slug }
						}
						if (
							that.$store.getters.inStockMenus.some(
								(menu) => menu.type == MenuType.EMBEDDED
							)
						) {
							that.$store.dispatch("clearUserData")
							successRoute.query = {
								success: "true"
							}
						}
						that.$router.push(successRoute)
					}
				} else if (mutation.type == "chargeCardFailed") {
					hasError = true
					errorMessage = "Charge Card Failed"
					if (
						mutation.payload &&
						mutation.payload.error &&
						mutation.payload.error.code
					) {
						switch (mutation.payload.error.code) {
							case ChargeCardError.INVALID_COUPON_ERROR: {
								errorMessage =
									"The coupon you entered is no longer valid, please try again"
								break
							}
							case ChargeCardError.INVALID_BUSINESS_RESERVATION_ERROR: {
								errorMessage =
									"Invalid hotel reservation, please try again"
								break
							}
							default: {
								errorMessage =
									"Charge Card Failed, code: " +
									mutation.payload.error.code
							}
						}
					}
				}

                if (hasError) {
                    this.toggleLoader(false)
                    that.$store.dispatch("sendMixpanelEvent", {
                        msg: "Purchase Processing Error",
                        data: {
                            type: that.$store.state.paymentMethod
                        }
                    })
                    that.bugsnag.notify(errorMessage, (event) => {
						event.addMetadata("data", {
							paymentMethod: that.$store.state.paymentMethod
						})
					})
                    that.$store.dispatch("setChargeKey")
                    eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
                        message: errorMessage,
                        type: NotificationType.ERROR
                    })
                }
            })
        },
        detectItemModalRoute: function(to) {
			if (to.query.editing && to.query.item_id) {
				this.$refs.itemModal.open({
					editing: true
				})
			}
        },
        recalculateCoupon() {
            if (this.$store.state.coupon && this.$store.state.coupon.id != 0 && this.$store.state.coupon.code && this.$store.state.coupon.code != "") {
                this.$store.dispatch("calcDiscount", this.$store.state.coupon.code).catch(() => {})
            }
        },
        setDefaultPaymentMethod() {
            if (
                this.paymentMethodSelected == null &&
                this.allowedPaymentMethods.length > 0
            ) {
                if (
                    this.allowedPaymentMethods.includes(
                        PaymentType.CREDIT_CARD
                    )
                ) {
                    this.paymentMethodSelected = PaymentType.CREDIT_CARD
                } else {
                    const method = this.paymentMethods.find((option) =>
                        this.allowedPaymentMethods.includes(option.id)
                    )
                    if (method) {
                        this.paymentMethodSelected = method.id
                    }
                }
            }
        }
    },
    watch: {
        minimumNotMet(newValue) {
            if (newValue) {
                this.$store.dispatch("sendMixpanelEvent", {
                    msg: "App Minimum Alert"
                })
            }
        }
    },
    created: function() {
		this.subscribeToChargeEvents()
    },
    mounted: function() {
        this.recalculateCoupon()
    },
    beforeDestroy: function () {
        this.chargeSubscription()
        this.chargeSubscription = null
    }
}

export default checkoutMixin